<template>
    <el-dialog v-dialogDrag class="dialog" width="800px" :visible.sync="dialogVisible"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                导出excel
            </div>
        </div>

        <div class="dialog_body">
            <div style="padding: 10px;font-size: 14px;font-weight: bold">
                <span style="padding-right: 30px">选择你要导出的字段</span>
                <el-radio-group v-model="radio" @change="selTitle">
                    <el-radio label="name">中文字段</el-radio>
                    <el-radio label="key">英文字段</el-radio>
                </el-radio-group>
            </div>
            <div class="Xdriver"></div>
            <div style="padding: 10px;">
                <el-checkbox-group v-model="selData" @change="selCheck">
                    <el-checkbox
                            v-for="(item,index) in outportKey"
                            :key="index"
                            :disabled="item.disabled"
                            :label="item[radio]"
                            style="margin: 10px"
                            border>
                    </el-checkbox>
                </el-checkbox-group>
            </div>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="success" @click="ok">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "outport",
        props: ['outportKey', 'dataList','excelName'],
        data() {
            return {
                dialogVisible: true,
                selKey: [],
                selData: [],
                radio: 'name'
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.initData();
            })
        },
        methods: {
            initData() {
                this.selData = [];
                this.selKey = [];
                this.outportKey.map(item => {
                    if (item.checked) {
                        this.selData.push(item[this.radio]);
                        this.selKey.push(item['key']);
                    }
                })
            },
            selTitle() {
                this.initData();
            },
            selCheck(list) {
                this.selData = [];
                this.selKey = [];
                list.map(seldata => {
                    this.outportKey.map(item => {
                        if (item[this.radio] === seldata) {
                            this.selData.push(item[this.radio]);
                            this.selKey.push(item['key']);
                        }
                    })
                })
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            ok() {
                //excel数据导出
                require.ensure([], () => {
                    const {export_json_to_excel} = require("@/Excel/Export2Excel");
                    const tHeader = this.selData;
                    const filterVal = this.selKey;
                    const list = this.dataList;
                    console.log(list)
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, this.excelName);
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]));
            },
        }
    }
</script>

